const google = {
    "help-automate": `Esta automatizacion 
    sirve para poder coger emails de tu correo electronico por lo que es necesario que revises tu entrada`,
    "help-connection": `Para conectar google vas a necesitar
    tu correo electronico`,
}

export default google;